import { fetchDashboardRequest } from '~/api/dashboard';
import { FetchDashboardResponse } from '~/api/dashboard/_types';
import { ApiSimpleResponseContext } from '~/plugins/apiClient/_types';

export const fetchDashboard = async (): Promise<ApiSimpleResponseContext<FetchDashboardResponse | null>> => {
    return await fetchDashboardRequest();
};
